import React, { useMemo, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import useGetData from "../../../hooks/apihooks/useGetData";

const AdminCertification = () => {
  // const [data, setData] = useState([]);
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetData(
    "certification",
    "getAllcertification"
  );

  console.log(data, "data");

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
        size: 100,
      },
      {
        id: "image_url",
        header: "Image",
        Cell: ({ row }) => (
          <>
            <img
              src={row?.original?.image_url}
              alt="img"
              width={50}
              height={50}
            />
          </>
        ),
      },

      {
        accessorKey: "title",
        header: "Title",
      },

      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <PencilIcon
                onClick={() =>
                  navigate(`edit`, {
                    state: { id: row?.original?.id, value: row?.original },
                  })
                }
                className="w-5 h-5 cursor-pointer mx-2"
              />

              <TrashIcon
                onClick={() => handleDelte(row?.original?.id)}
                className="w-5 h-5 cursor-pointer mx-2"
              />
            </div>
          </>
        ),
      },
    ],
    []
  );

  const handleDelte = () => {};
  return (
    <div>
      <AdminTabelHeader
        title={"Certification"}
        btnStatus={true}
        path="add"
        btnname="Add"
      />
      <MaterialReactTable
        columns={columns}
        data={data || []}
        enableColumnResizing
        enableColumnOrdering
      />
    </div>
  );
};

export default AdminCertification;
